import styled, { css } from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { fontWeight, radius, color, spacing, variant, themeMode, palette } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';

const variantKindStyles = variant({
  prop: "variant",
  compoundProp: "kind",
  variants: {
    default: {
      color: themeMode({ light: "neutral.900", dark: "neutral.50" }),
      base: {
        backgroundColor: themeMode({ light: "neutral.200", dark: "neutral.800" })
      },
      subtle: {
        backgroundColor: themeMode({ light: palette("neutral.200", 0.24), dark: palette("neutral.800", 0.48) })
      }
    },
    primary: {
      base: {
        color: "neutral.900",
        backgroundColor: "primary.500"
      },
      subtle: {
        color: themeMode({ light: "primary.700", dark: "primary.300" }),
        backgroundColor: palette("primary.500", 0.24)
      }
    },
    secondary: {
      base: {
        color: "neutral.50",
        backgroundColor: "secondary.500"
      },
      subtle: {
        color: "secondary.300",
        backgroundColor: palette("secondary.500", 0.24)
      }
    },
    danger: {
      base: {
        color: "neutral.50",
        backgroundColor: "danger.500"
      },
      subtle: {
        color: "danger.300",
        backgroundColor: palette("danger.500", 0.24)
      }
    },
    warning: {
      base: {
        color: "neutral.900",
        backgroundColor: "warning.500"
      },
      subtle: {
        color: themeMode({ light: "warning.700", dark: "warning.300" }),
        backgroundColor: palette("warning.500", 0.24)
      }
    },
    success: {
      base: {
        color: "neutral.50",
        backgroundColor: "success.500"
      },
      subtle: {
        color: themeMode({ light: "success.700", dark: "success.300" }),
        backgroundColor: palette("success.500", 0.24)
      }
    },
    bronze: {
      base: {
        color: "neutral.50",
        backgroundColor: "bronze.500"
      },
      subtle: {
        color: themeMode({ light: "bronze.700", dark: "bronze.300" }),
        backgroundColor: palette("bronze.500", 0.24)
      }
    },
    silver: {
      base: {
        color: "neutral.50",
        backgroundColor: "silver.500"
      },
      subtle: {
        color: themeMode({ light: "silver.700", dark: "silver.300" }),
        backgroundColor: palette("silver.500", 0.24)
      }
    },
    gold: {
      base: {
        color: "neutral.50",
        backgroundColor: "gold.500"
      },
      subtle: {
        color: themeMode({ light: "gold.700", dark: "gold.300" }),
        backgroundColor: palette("gold.500", 0.24)
      }
    },
    platinum: {
      base: {
        color: "neutral.900",
        background: `linear-gradient(
                    315deg,
                    #adb7bf 0%,
                    #dfe3e9 50%,
                    #6c7782 100%
                )`
      },
      subtle: {
        color: themeMode({ light: "platinum.600", dark: "platinum.50" }),
        background: `linear-gradient(
                    315deg,
                    #adb7bf66 0%,
                    #dfe3e966 50%,
                    #6c778266 100%
                )`
      }
    }
  }
});
const sizeStyles = variant({
  prop: "size",
  variants: {
    sm: {
      textTransform: "uppercase",
      height: "16px",
      minWidth: "16px"
    },
    md: {
      height: "24px",
      minWidth: "24px"
    }
  }
});
const contentSizeStyles = variant({
  prop: "size",
  variants: {
    sm: {
      py: "0",
      px: "xs",
      fontSize: "xs",
      lineHeight: "16px",
      svg: {
        marginRight: "xxs"
      }
    },
    md: {
      py: "0",
      px: "xs",
      fontSize: "sm",
      lineHeight: 1,
      svg: {
        marginRight: "xxs"
      }
    }
  }
});
const Badge = styled(Box)`
    display: inline-flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    align-content: center;
    text-align: center;
    white-space: nowrap;
    user-select: none;
    font-weight: ${fontWeight("bold")};
    border-radius: ${({ isRounded }) => isRounded ? radius("round") : radius("base")};
    cursor: ${({ onClick }) => onClick ? "pointer" : "inherit"};

    ${variantKindStyles};
    ${sizeStyles};

    ${({ isPinned }) => isPinned && css`
            box-shadow: 0px 0px 0px 2px ${color("background.base")};
        `};
`;
styled(Box)``;
const Content = styled(Box).attrs(() => ({ as: "span" }))`
    display: inline-flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    align-content: center;
    ${contentSizeStyles};
`;
const Dot = styled(Box)`
    width: ${spacing("sm")};
    height: ${spacing("sm")};

    ${variantKindStyles};
    border-radius: ${radius("round")};

    ${({ isPinned }) => isPinned && css`
            box-shadow: 0px 0px 0px 2px ${color("background.base")};
        `};
`;

export { Badge, Content, Dot };
//# sourceMappingURL=styled.es.js.map
